import { gql } from "@apollo/client";

export const ME = gql`
	query Me {
		me {
			name
			email
			role
			telegramId
			approvedTelegramId
		}
	}
`;

export const UPDATE_TELEGRAM_ID = gql`
	mutation UpdateTelegram($telegramId: String!) {
		updateTelegramId(telegramId: $telegramId) {
			telegramId
		}
	}
`;
